import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { IUser } from "@interfaces/IUser";
import { UserType } from "@enums/UserType";
import { AccountService, IAccount } from "@services/account.service";
import { CurrentUserService } from "@services/currentUser.service";
import { LoginService } from "@services/login.service.ajs";
import "./accountSwitcher.component.scss";
import { PreferencesService } from "@app/services/preferences.service";
import { NavigationService } from "@app/services/navigation.service";

@Component({
    selector: "account-switcher",
    template: require("./accountSwitcher.component.html")
})

export class AccountSwitcherComponent implements OnChanges, OnInit {
    currentUser: IUser;
    accountList: IAccount[] = [];
    UserType = UserType;
    loading = false;

    @Output() onAccountSwitched: EventEmitter<number> = new EventEmitter<number>();

    // ---

    private currentAccount: IAccount;

    constructor(
        private readonly accountService: AccountService,
        private readonly loginService: LoginService,
        private readonly currentUserService: CurrentUserService,
        private readonly preferencesService: PreferencesService,
        private readonly navigationService: NavigationService) {
    }

    ngOnInit(): void {
        this.currentUserService.getCurrentUser().then(currentUser => {
            this.currentUser = currentUser;
        });
    }

    ngOnChanges(changes: SimpleChanges) {

        this.accountList = [];
        this.loading = true;
        // Create account list switcher component.
        this.accountService.getMultiAccountUserMappings().then(accountList => {
            accountList.forEach(accountMapping => {
                this.accountList.push({
                    Id: accountMapping.Id,
                    CompanyName: accountMapping.CompanyName,
                    Image: accountMapping.Image
                });
                this.loading = false;
            });
        });

        this.accountService.getAccountData(true).then(currentAccount => {
            this.currentAccount = currentAccount;
        });
    }

    switchToAccount(account: IAccount) {
        this.loading = true;

        this.loginService.switchAccount(account.Id, !!this.currentAccount).then(() => {
            this.preferencesService.reconcileLanguagesRequiresRefresh().then(() => {
                this.accountService.getAccountData(true).then(currentAccount => {
                    this.currentAccount = currentAccount;
                    this.loading = false;
                });
                this.onAccountSwitched.emit(account.Id);
            });
        });
    }

    switchToInternal() {
        this.loading = true;

        this.loginService.switchToInternal().then(() => {
            this.loading = false;
            this.onAccountSwitched.emit(null);
        });;
    }

    // ---

    //private removeClass(className: string,) {
    //    this.renderer.removeClass(this.elementRef.nativeElement, className);
    //}
}
